<template>
    <form key="email" @submit.prevent="submit()" @keypress.enter="submit()" class="lc-confirm-email-stage form">
        <header class="form__header">
            <p class="form__title">We've sent a 6-digit confirmation code to <strong>{{ form.email }}</strong>. It will expire shortly, so enter it soon.</p>
        </header>

        <label for="name" class="form__label">Your confirmation code</label>
        <div class="form__code">
            <input v-for="code in firstCodes"
                   :key="code.index"
                   v-model="code.value"
                   @input="onInput(code)"
                   @paste.prevent="onPaste"
                   ref="input"
                   class="form__input"
                   :class="{ 'form__input--busy' : form.busy }"
                   maxlength="1"
                   size="1"
                   autocomplete="off"
                   autofocus
            />
            <aside class="form__code__divider" />
            <input v-for="code in lastCodes"
                   :key="code.index"
                   v-model="code.value"
                   @input="onInput(code)"
                   @paste.prevent="onPaste"
                   ref="input"
                   class="form__input"
                   :class="{ 'form__input--busy' : form.busy }"
                   maxlength="1"
                   size="1"
                   autocomplete="off"
            />
        </div>
        <div v-if="isInvalid" class="form__help form__help--error">That code wasn't correct. Give it another go!</div>

        <footer class="form__footer">
            <p class="form__help">Not received your code? Check your spam folder</p>
        </footer>
    </form>
</template>
<script>
import Form from '../../../helpers/Form'

export default {
    props: {
        form: {
            type: Form,
            required: true
        }
    },

    data () {
        return {
            isInvalid: false,
            codes: [
                { index: 0, value: '' },
                { index: 1, value: '' },
                { index: 2, value: '' },
                { index: 3, value: '' },
                { index: 4, value: '' },
                { index: 5, value: '' }
            ]
        }
    },

    watch: {
        code (value) {
            if (value.length === 6) {
                this.submit()
            }
        }
    },

    methods: {
        submit () {
            this.form.code = this.code
            this.isInvalid = false

            this.form.post('/api/registration/confirm-code').then(() => {
                this.$router.push('/create/team')
            }).catch(() => {
                this.isInvalid = true
            })
        },

        onInput ({ index, value }) {
            if (isNaN(value) === false && value.length > 0) {
                return this.next(index)
            }

            this.codes[index].value = ''
        },

        next (index) {
            if (index >= this.codes.length - 1) {
                return
            }

            this.$refs['input'][index + 1].focus()
        },

        onPaste (event) {
            const clip = event.clipboardData.getData('text').slice(0, 6)
            this.codes.forEach((code, index) => {
                const char = clip.charAt(index)

                this.replaceCode(code, char)
            })
        },

        replaceCode (code, char) {
            if (isNaN(char) === false) {
                code.value = char
            }
        }
    },

    computed: {
        firstCodes () {
            return this.codes.slice(0, 3)
        },

        lastCodes () {
            return this.codes.slice(3, 6)
        },

        code () {
            return this.codes.map(code => code.value).join('')
        }
    }
}
</script>
